import sha1 from './sha1'

const objectHash = (data: unknown): string => sha1(JSON.stringify(data))
export default objectHash
